var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade china-modal confirmation-popup",
      attrs: { id: "chinaUserConsentPopup", role: "dialog" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header generic-header" }, [
              _vm._v(" Terms and Conditions "),
            ]),
            _c(
              "div",
              { staticClass: "modal-body pt-0" },
              [
                [
                  _c("div", { staticClass: "activityTracker-checkbox mb-15" }, [
                    _c("span", { staticClass: "checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dataConsent,
                              expression: "dataConsent",
                            },
                          ],
                          attrs: { type: "checkbox", name: "terms-private" },
                          domProps: {
                            checked: Array.isArray(_vm.dataConsent)
                              ? _vm._i(_vm.dataConsent, null) > -1
                              : _vm.dataConsent,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.dataConsent,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.dataConsent = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.dataConsent = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.dataConsent = $$c
                              }
                            },
                          },
                        }),
                        _vm._m(0),
                      ]),
                    ]),
                    _vm._m(1),
                  ]),
                ],
              ],
              2
            ),
            _c("div", { staticClass: "modal-footer text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn emergo-blue-button",
                  attrs: { type: "button", disabled: _vm.disableSubmit },
                  on: {
                    click: function ($event) {
                      return _vm.updateConsent()
                    },
                  },
                },
                [_vm._v(" Submit ")]
              ),
            ]),
          ]),
          _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "cr" }, [
      _c("img", {
        staticClass: "select-check",
        attrs: { src: "/static/images/icons/select_check.svg", alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "terms-conditions ml-15", attrs: { for: "terms" } },
      [
        _vm._v(
          " By clicking this checkbox, I agree Emergo by UL Solutions may process my personal information in accordance with the "
        ),
        _c(
          "a",
          {
            staticClass: "term-priv",
            attrs: {
              href: "https://www.ul.com/resources/online-policies",
              target: "_blank",
            },
          },
          [_vm._v("Emergo by UL Solutions’ Online Policies ")]
        ),
        _vm._v(
          " and to the cross-border transfer of my personal information to the United States. "
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }